import utils = egr.wcf.utils;
import { AppConfigurationStore } from '../stores/AppConfigurationStore';
import { FloorPlanActions } from '../actions/FloorPlanActions';
import { ProjectInstance } from './ProjectInstance';
import { AppProjectManager } from './AppProjectManager';
import { ProjectManagerStore } from '../stores/ProjectManagerStore';
import { FloorPlanSettings, ProjectSettingsStore } from '../stores/ProjectSettingsStore';

export const FloorPlanContentFileName: string = 'floor_plan.data';

export abstract class FloorPlanManager {
    private static browserStorage: string | null = null;

    public static reset(): void {
        FloorPlanManager.browserStorage = null;
    }

    public static async updateTexture(dataUrl: string): Promise<void> {
        if (AppConfigurationStore.getState().projectManagerAvailable) {
            const project: ProjectInstance | null = ProjectManagerStore.getCurrentProject();
            if (project != null) {
                await AppProjectManager.addTempResource(
                    project,
                    FloorPlanContentFileName,
                    dataUrl
                );
            }
        } else {
            FloorPlanManager.browserStorage = dataUrl;
        }
    }

    public static getFloorPlan(checkTmpPath: boolean = true, project?: ProjectInstance): Promise<string | null> {
        if (AppConfigurationStore.getState().projectManagerAvailable) {
            return FloorPlanManager.loadFloorPlanFromAppStorage(checkTmpPath, project);
        }

        return Promise.resolve(FloorPlanManager.browserStorage);
    }

    public static async importFloorPlanFromContainer(dataUrl: string): Promise<void> {
        await FloorPlanManager.updateTexture(dataUrl);
        await FloorPlanManager.loadFloorPlan(true);
    }

    public static async loadFloorPlan(checkTmpPath: boolean = false, project?: ProjectInstance): Promise<void> {
        const dataUrl: string | null = await FloorPlanManager.getFloorPlan(checkTmpPath, project);

        if (utils.string.isNullOrEmpty(dataUrl)) {
            return;
        }

        const settings: FloorPlanSettings | null = ProjectSettingsStore.getState().floorPlan;
        if (settings != null && settings.width != null && settings.height != null) {
            FloorPlanActions.setFloorPlanTexture(dataUrl, settings.width, settings.height, false);

            if (settings.brightness != null) {
                FloorPlanActions.setBrightness(settings.brightness);
            }

            if (settings.opacity != null) {
                FloorPlanActions.setVisibility(settings.opacity);
            }

            if (settings.colorReduction != null) {
                FloorPlanActions.setColorReduction(settings.colorReduction);
            }
        }
    }

    private static async loadFloorPlanFromAppStorage(checkTmpPath: boolean, project?: ProjectInstance | null): Promise<string | null> {
        if (project == null) {
            project = ProjectManagerStore.getCurrentProject();
        }

        if (project != null) {
            let dataUrl: string | null = null;
            if (checkTmpPath === true) {
                dataUrl = await AppProjectManager.getProjectTextResource(project, FloorPlanContentFileName, true);
            }

            if (utils.string.isNullOrEmpty(dataUrl) && project.isNew === false) {
                dataUrl = await AppProjectManager.getProjectTextResource(project, FloorPlanContentFileName, false);
            }

            return dataUrl;
        }

        return null;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/FloorPlanManager.ts